import { MOKA_INVENTORY_API } from 'api/constants';

export const MODIFIERS = `${MOKA_INVENTORY_API}/v2/modifiers`;
export const V1_MODIFIER = `${MOKA_INVENTORY_API}/v1/modifiers`;
export const MODIFIER_BY_ID = id => `${MOKA_INVENTORY_API}/v1/modifiers/${id}`;
export const V1_DELETE_MODIFIER = id =>
  `${MOKA_INVENTORY_API}/v1/modifiers/${id}/delete_modifier`;
export const CREATE_ALL_OUTLET = `${MOKA_INVENTORY_API}/v1/modifiers/create_all_outlet`;
export const V1_APPLY_TO_ITEMS = id =>
  `${MOKA_INVENTORY_API}/v1/modifiers/${id}/apply_to_items`;
export const V1_SHOW_ITEM_MODIFIER = () =>
  `${MOKA_INVENTORY_API}/v1/modifiers/show_item_modifier`;
export const GET_MODIFIERS_LIST = `${MOKA_INVENTORY_API}/v1/modifiers/get_modifiers_list`;
